import { StyleSheet, View } from "react-native";
import { useCustomTheme } from "@luna-restaurant/ui";
import { MenuLabel } from "./MenuLabel";
export const ReadOnlyMenuItem = ({ item }) => {
    const { colors, fonts } = useCustomTheme();
    return (<View style={[
            styles.container,
            {
                backgroundColor: colors.successLighter,
            },
        ]}>
      <View style={styles.firstRow}>
        <MenuLabel label={item.label}/>
      </View>

      <View>
        <div style={{
            ...styles.menuText,
            color: colors.text,
            ...fonts.bold,
        }} dangerouslySetInnerHTML={{
            __html: item.title,
        }}/>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        padding: 8,
        paddingBottom: 12,
        borderRadius: 4,
    },
    firstRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 10,
        height: 24,
    },
    menuText: {
        fontSize: 15,
    },
});
//# sourceMappingURL=ReadOnlyMenuItem.web.js.map